import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { VproService } from "src/app/service/vpro/vpro.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { Physician } from "src/app/models/physician";
import { sortBy } from 'underscore';

@Component({
  selector: 'app-delete-doctor-profile',
  templateUrl: './delete-doctor-profile.component.html',
  styleUrls: ['./delete-doctor-profile.component.css']
})
export class DeleteDoctorProfileComponent implements OnInit {
  form: UntypedFormGroup;
  users: Physician[] = [];
  selectedUsers: Number[] = [];

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private service: VproService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.form = this._formBuilder.group({
      name: [null],
    });
  }

  search() {
    this.spinner.show();
    this.users = [];
    let data = {
      name: this.form.value.name,
      org_code: localStorage.getItem("orgcode")
    }
    this.service.fetchPhysicians(data).subscribe(
      (response) => {
        this.spinner.hide();
        if (response && response['result'] && response['result'].length > 0) {
          this.users = response['result'];
          this.users = sortBy(this.users, 'first_name'); // Data Sorter via underscore.js
          for (let i = 0; i < this.users.length; i++) {
            this.users[i].name = this.users[i].first_name.trim() + ' ' + this.users[i].last_name.trim();
            // this.users[i].ppurl = this.users[i].ppurl;
            this.users[i].avatarimg = this.users[i].ppurl.substring(this.users[i].ppurl.lastIndexOf('/') + 1);
            // console.log("avatar for Phy", this.users[i].avatarimg);
          }
        }
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  markSelected(event) {
    this.selectedUsers = this.users
      .filter((u: any) => u.checked)
      .map((u) => u.u_id);
  }

  open(content) {
    this.modalService.open(content, { centered: true }).result.then(
      (result) => {
        this.deleteProfiles();
      },
      (reason) => {
        console.log("reason", reason);
      }
    );
  }

  deleteProfiles() {
    this.spinner.show();
    this.service.deleteUsers("physicians", { u_ids: this.selectedUsers }).subscribe(
      (response) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });

        Toast.fire({
          type: "success",
          title: "Physician profile has been deleted successfuly",
        });
        this.selectedUsers = [];
        this.users = [];
        this.form.value.name = "";
        this.modalService.dismissAll();
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }
}
